<template>
    <b-form-group label-for="select-user">
        <template slot="label">
            <strong>{{ $t('form.label.evaluated') + '*' }}</strong>
        </template>
        <users
            id="select-user"
            :state="state"
            close-on-select
            clear-on-select
            :options="options"
            :selected="selected"
            :loading="isLoading"
            :internal-search="false"
            aria-describedby="users"
            :next-page-button="nextPageUserOptions"
            :placeholder="$t('values.chooseAuserOrTypeForMoreResults')"
            :noOptionsFound="
                $t('form.placeholder.noOptionsFoundSelectSomeQuestionnaire')
            "
            @changeSearch="onchangeSearch"
            @next-page="onClickNextPageUsers"
            @changeValue="$emit('update:selected', $event)"
        />
        <b-form-invalid-feedback id="users">
            {{ $t('form.placeholder.selectedEvaluated') + '.' }}
        </b-form-invalid-feedback>
    </b-form-group>
</template>
<script>
import { SelectWithAvatar } from '@/views/components/selects'
import { debounce } from 'lodash'
import { getQuestionnaireAllowedUsers } from '@/views/values/api'
import { mapperToOptions } from '@/views/components/selects/select-with-avatar'

export default {
    props: {
        selected: {
            type: Object,
            default: null,
        },
        state: {
            type: Boolean,
            default: null,
        },
        questionnaireId: {
            type: Number,
            default: null,
        },
        valuerId: {
            type: Number,
            required: true,
        },
    },
    components: {
        Users: SelectWithAvatar,
    },
    data() {
        return {
            options: [],
            searchName: '',
            isLoading: false,
            paginaton: {
                page: 1,
                lastPage: 1,
                perPage: 50,
            },
            debouncedSearchUsersHandler: debounce(this.onChangeSearch, 1000),
        }
    },
    methods: {
        onchangeSearch(searchName) {
            if (this.questionnaireId) {
                this.debouncedSearchUsersHandler(searchName)
            }
        },
        onClickNextPageUsers() {
            this.paginaton.page++
            this.getQuestionnaireAllowedUsers()
        },
        onChangeSearch(searchName) {
            this.searchName = searchName
            this.getQuestionnaireAllowedUsers()
        },
        getQuestionnaireAllowedUsers() {
            this.isLoading = true
            getQuestionnaireAllowedUsers(
                this.questionnaireId,
                this.valuerId,
                this.searchName,
                this.paginaton.perPage,
                this.paginaton.page
            ).then(data => {
                if (data.current_page > 1) {
                    this.options = this.options.concat(
                        mapperToOptions(data.data)
                    )
                } else {
                    this.options = mapperToOptions(data.data)
                }

                this.paginaton.lastPage = data.last_page
                this.isLoading = false
            })
        },
    },
    computed: {
        nextPageUserOptions() {
            return {
                loading: this.isLoading,
                isShowNextPage: this.paginaton.lastPage > 1,
                isLastPage: this.paginaton.page == this.paginaton.lastPage,
            }
        },
    },
    watch: {
        questionnaireId(newId, oldId) {
            if (newId !== oldId && newId !== null) {
                this.options = []
                this.getQuestionnaireAllowedUsers()
            }
        },
    },
}
</script>
